import { Navigate, Outlet } from "react-router-dom";
import { LayoutDashboard, Building2, Boxes, CreditCard, Globe, MapPin, ShieldCheck, Mail, ScrollText, Settings, SlidersHorizontal, Activity } from "lucide-react";
import { Shell } from "@/components/app/Shell";
import { FullPageLoader } from "@/components/app/kit";
import { useAuth, homeFor } from "@/context/AuthContext";
import { t } from "@/lib/i18n";

const SECTIONS = [
  { label: "Pilotage", items: [
    { to: "/admin", end: true, label: "Tableau de bord global", icon: LayoutDashboard, testid: "nav-admin-dashboard" },
    { to: "/admin/cabinets", label: "Cabinets médicaux", icon: Building2, testid: "nav-admin-tenants" },
  ] },
  { label: "Offre", items: [
    { to: "/admin/modules", label: "Modules et fonctionnalités", icon: Boxes, testid: "nav-admin-modules" },
    { to: "/admin/formules", label: "Plans d'abonnement", icon: CreditCard, testid: "nav-admin-plans" },
  ] },
  { label: "Infrastructure", items: [
    { to: "/admin/domaines", label: "Domaines et sous-domaines", icon: Globe, testid: "nav-admin-domains" },
    { to: "/admin/pays", label: "Pays et paramètres régionaux", icon: MapPin, testid: "nav-admin-countries" },
    { to: "/admin/supervision", label: "Supervision technique", icon: Activity, testid: "nav-admin-monitoring" },
  ] },
  { label: "Administration", items: [
    { to: "/admin/administrateurs", label: "Utilisateurs administrateurs", icon: ShieldCheck, testid: "nav-admin-admins" },
    { to: "/admin/notifications", label: "Notifications et modèles", icon: Mail, testid: "nav-admin-notifications" },
    { to: "/admin/audit", label: "Journaux d'audit", icon: ScrollText, testid: "nav-admin-audit" },
    { to: "/admin/configuration", label: "Paramètres de la plateforme", icon: SlidersHorizontal, testid: "nav-admin-config" },
    { to: "/admin/parametres", label: "Paramètres généraux", icon: Settings, testid: "nav-admin-settings" },
  ] },
];

export default function PlatformLayout() {
  const { me } = useAuth();
  if (me === null) return <FullPageLoader />;
  if (!me) return <Navigate to="/connexion" replace />;
  if (me.space !== "platform") return <Navigate to={homeFor(me)} replace />;
  return (
    <Shell sections={SECTIONS} spaceLabel="Super Administration" roleLabel={t(`role.${me.user.platform_role}`)}>
      <Outlet />
    </Shell>
  );
}
